import * as Icons from "lucide-react";

const OurPromiseStrip = ({ promiseData }) => {
  const items = (promiseData?.items || []).map(item => ({
    ...item,
    icon: Icons[item.icon] || Icons.Star
  }));

  return (
  <section className="bg-secondary py-20 border-y border-primary/5">
    <div className="container">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-6">
        {promiseData?.title || "Our"} <span className="text-primary">{promiseData?.highlight || "Promise"}</span>
      </h2>
      <div className="grid grid-cols-3 md:flex md:justify-center md:gap-10 gap-y-5 gap-x-2">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <div key={item.label} className="flex flex-col items-center gap-2 text-center">
              <div className="w-12 h-12 rounded-full border-2 border-primary/30 flex items-center justify-center bg-primary/5">
                <Icon className="h-5 w-5 text-primary" />
              </div>
              <span className="text-xs font-semibold text-foreground font-sans leading-tight max-w-[90px]">
                {item.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  </section>
  )
};


export default OurPromiseStrip;
